var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-btn', {
    attrs: {
      "color": "accent",
      "icon": ""
    },
    on: {
      "click": _vm.openGallery
    }
  }, [_c('v-icon', [_vm._v("$gallery")])], 1), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "width": "700"
    },
    model: {
      value: _vm.openModal,
      callback: function callback($$v) {
        _vm.openModal = $$v;
      },
      expression: "openModal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$t('galleryedit_choose_gallery')))]), _c('v-card-text', [_c('v-row', _vm._l(_vm.images, function (image) {
    return _c('v-col', {
      key: image,
      attrs: {
        "cols": "4"
      },
      on: {
        "click": function click($event) {
          return _vm.selectPicture(image);
        }
      }
    }, [_c('img', {
      class: {
        'selected': _vm.selectedPicture == image
      },
      attrs: {
        "src": image
      }
    })]);
  }), 1)], 1), _c('v-card-actions', [!_vm.isAvailable("editor.tabs.tools.image") ? _c('div', [_c('iframe-link', {
    attrs: {
      "link": "/#/upgrade",
      "content": _vm.$t('galleryedit_upgrade_today')
    }
  }), _vm._v(" " + _vm._s(_vm.$t('galleryedit_add_own_pictures')) + " ")], 1) : _vm._e(), _vm.isAvailable("editor.tabs.tools.image") ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('galleryedit_upload_tips'))
    }
  }) : _vm._e(), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t('close')))]), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }